/* eslint-disable */
import { register } from 'register-service-worker'
console.log('registration service-worker!!!!!')
if ('serviceWorker' in navigator) {
  console.log(`${process.env.BASE_URL}service-worker.js`)
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('App is being served from cache by a service worker.')
    },
    // eslint-disable-next-line no-unused-vars
    registered (registration) {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    // eslint-disable-next-line no-unused-vars
    updatefound (registration) {
      console.log('New content is downloading.')
    },
    // eslint-disable-next-line no-unused-vars
    updated (registration) {
      console.log('New content is available and will be refresh.')
      caches.keys().then(function(names) {
        for (let name of names) {
          caches.delete(name)
        }
      })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
} else {
  console.log('Your browser does not support the Service-Worker!')
}

// self.addEventListener('message', (e) => {
//   if (e.data.action == 'skipWaiting') {
//     console.log('SKIP WAITENG!!!!!!!!!!!!!!!!!!!!!!!!!')
//     self.skipWaiting()
//   }
// })